import React, { useRef } from 'react';

// Convert YYYY-MM-DD to MM/DD/YYYY for display
const toDisplay = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${m}/${d}/${y}`;
};

// Convert MM/DD/YYYY to YYYY-MM-DD for internal use
const toISO = (display) => {
  if (!display) return '';
  const match = display.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) return '';
  const [, m, d, y] = match;
  return `${y}-${m}-${d}`;
};

// Auto-format: insert slashes as user types
const autoFormat = (raw) => {
  const digits = raw.replace(/\D/g, '').substring(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return digits.substring(0, 2) + '/' + digits.substring(2);
  return digits.substring(0, 2) + '/' + digits.substring(2, 4) + '/' + digits.substring(4);
};

export default function DateInput({ className, value, onChange, placeholder, required, min, max, ...rest }) {
  const displayVal = toDisplay(value);
  const hiddenRef = useRef();

  const handleTextChange = (e) => {
    const formatted = autoFormat(e.target.value);
    e.target.value = formatted;
    if (formatted.length === 10) {
      const iso = toISO(formatted);
      if (iso) onChange(iso);
    }
  };

  const handlePickerChange = (e) => {
    if (e.target.value) onChange(e.target.value);
  };

  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
      <input
        type="text"
        className={className}
        placeholder={placeholder || 'MM/DD/YYYY'}
        defaultValue={displayVal}
        key={value}
        maxLength={10}
        required={required}
        onChange={handleTextChange}
        style={{ paddingRight: 32 }}
        {...rest}
      />
      <input
        ref={hiddenRef}
        type="date"
        value={value || ''}
        min={min}
        max={max}
        onChange={handlePickerChange}
        style={{
          position: 'absolute',
          right: 4,
          width: 28,
          height: 28,
          opacity: 0,
          cursor: 'pointer',
        }}
        tabIndex={-1}
      />
      <span
        style={{
          position: 'absolute',
          right: 8,
          pointerEvents: 'none',
          fontSize: 16,
          color: 'var(--text-secondary)',
        }}
      >
        &#128197;
      </span>
    </div>
  );
}
